// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root___Khaa","header":"ClearentDisclaimer_header__3ea6_","inner":"ClearentDisclaimer_inner__2OgSk"};